import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'fgb-account-details-page',
  templateUrl: './account-details-page.component.html',
  styleUrls: ['./account-details-page.component.scss'],
})
export class AccountDetailsPageComponent {
  isProfilePage: boolean = this.route.snapshot.data.isProfilePage ?? false;
  titleKey: string = this.route.snapshot.data.titleKey ?? 'account.my-details.title';
  titleDefault: string = this.route.snapshot.data.titleDefault ?? 'My details';

  constructor(private route: ActivatedRoute) {}
}
